<template>
    <div>
        <h2>登録カード一覧</h2>
        <v-container>
            <v-row class="mt-4">
                <v-col v-for="(card, i) in cards" :key="i" cols="12" sm="6" lg="3" xl="2" class="text-center">
                    <v-card>
                        <v-img :src="url_prefix + card.image"></v-img>
                        <div class="pa-3">
                            <div>{{ card.card_name }}</div>
                            <div>{{ card.color }}</div>
                            <div>
                                {{ card.lot }}
                                <v-chip
                                    v-if="card.is_psa"
                                    color="red"
                                    dark
                                >
                                    PSAカード
                                </v-chip>
                            </div>
                        </div>
                        <v-card-actions>
                            <v-list-item class="grow">
                                <v-row
                                align="center"
                                justify="center"
                                >
                                    <v-btn
                                        class="mr-1"
                                        color="primary"
                                        @click="goEditCard(card.id)"
                                    >
                                        編集
                                    </v-btn>
                                    <v-btn
                                        class="ml-1"
                                        color="primary"
                                        @click="goRegisterEntry(card.id, card.image, card.card_name, card.color, card.lot)"
                                    >
                                        買取登録
                                    </v-btn>
                                </v-row>
                            </v-list-item>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            cards: [],
            url_prefix: "",
        }
    },
    methods: {
        goRegisterEntry(card_id, card_image, card_name, card_color, card_lot) {
            this.$router.push({
                name: 'RegisterEntry',
                params: {
                    card_id: card_id,
                    card_image: card_image,
                    card_name: card_name,
                    card_color: card_color,
                    card_lot: card_lot
                }
            })
        },
        goEditCard(card_id) {
            this.$router.push({
                name: 'EditCard',
                params: {
                    card_id: card_id,
                }
            })
        },
    },
    mounted: function () {
        this.url_prefix = `${process.env.VUE_APP_API_ORIGIN}`
        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/card/list`)
        .then(res => {
            this.cards = res.data
        })
        .catch(() => {
            alert(e)
        })
    }
}
</script>
  